export const APP_LAYOUT_SET_MARGIN = 'APP_LAYOUT_SET_MARGIN';
export const APP_LAYOUT_ADJUST_BASED_ON_STORIES = 'APP_LAYOUT_ADJUST_BASED_ON_STORIES';
